import { ldapConstants } from '../constants/ldap.constants';

export function ldapServers(state = {}, action) {
  switch (action.type) {
    case ldapConstants.CREATE_REQUEST:
    case ldapConstants.UPDATE_REQUEST:
    case ldapConstants.FETCH_REQUEST:    
    case ldapConstants.GET_REQUEST:
    case ldapConstants.REMOVE_REQUEST:
    case ldapConstants.TEST_REQUEST:
      return {
        ...state,
        loading: true
      };    
    case ldapConstants.CREATE_SUCCESS:
    case ldapConstants.GET_SUCCESS:
    case ldapConstants.UPDATE_SUCCESS:
    return{
      ...state,
      item: action.ldapServer,
      loading: false
    }    
    case ldapConstants.TEST_SUCCESS:
    case ldapConstants.TEST_FAILURE:    
    return{
      ...state,
      testResult: action.testResult,
      loading: false
    }    
    case ldapConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.ldapServers,
        loading: false
      };
    case ldapConstants.CREATE_FAILURE:
    case ldapConstants.FETCH_FAILURE:
    case ldapConstants.GET_FAILURE:
    case ldapConstants.REMOVE_FAILURE:
    case ldapConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state
  }
}
